import { useState } from 'react';
import { Link } from 'react-router'; // Hamesha react-router
import { FaCartShopping, FaBars, FaXmark } from "react-icons/fa6"; // Added hamburger icons
import { useSelector } from 'react-redux';

import { APP_LOGO_URL } from '../../utils/constants';

const Nav = function() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const cartItems = useSelector(store => store.cart.items);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav>
            <div className="head-wrapper">
                {/* 1. Logo */}
                <Link to='/' className="logo-link" onClick={() => setIsMenuOpen(false)}>
                    <div className="logo-con">
                        <div className="img-con">
                            <img src={APP_LOGO_URL} alt="Crave Dash Logo" />
                        </div>
                        <p>Crave Dash</p>
                    </div>
                </Link>

                {/* 2. Desktop Navigation (Hidden on Mobile) */}
                <div className="nav-item desktop-menu">
                    <ul>
                        <li><Link to='/'>Home</Link></li>
                        <li><Link to='/about-us'>About</Link></li>
                        <li><Link to='/contact-us'>Contact</Link></li>
                    </ul>
                </div>

                {/* 3. Actions: Cart (Always visible) & Hamburger (Mobile only) */}
                <div className="nav-actions">
                    {/* Premium Cart Icon with Badge */}
                    <Link to='/cart' className="cart-icon-btn" onClick={() => setIsMenuOpen(false)}>
                        <FaCartShopping className="icon" />
                        {cartItems.length > 0 && (
                            <span className="cart-badge">{cartItems.length}</span>
                        )}
                    </Link>

                    {/* Mobile Hamburger Toggle */}
                    <button className="mobile-menu-btn" onClick={toggleMenu}>
                        {isMenuOpen ? <FaXmark /> : <FaBars />}
                    </button>
                </div>
            </div>

            {/* 4. Mobile Dropdown Menu */}
            {isMenuOpen && (
                <div className="mobile-dropdown">
                    <ul>
                        <li><Link to='/' onClick={toggleMenu}>Home</Link></li>
                        <li><Link to='/about-us' onClick={toggleMenu}>About</Link></li>
                        <li><Link to='/contact-us' onClick={toggleMenu}>Contact</Link></li>
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default Nav;